import React from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';

import Colors from '../theming/Colors';
import { ImageServiceType, parseImageUrl } from '../utilities/utilities';
import KitImage from './KitImage';

//******************************************************************************
// Types
//******************************************************************************

export interface IProps {
  backgroundColor?: string; // loading state background color
  borderRadius?: number;
  imageUrl?: string;
  size: number;
  style?: ViewStyle;
  testID?: string;
  tintColor?: string;
}

// This implementation is intended for usage with branding composites
// where the background color and logo insets are handled within the image itself.
export default function KitCompositeImage({
  backgroundColor = Colors.N200,
  borderRadius,
  imageUrl,
  size,
  style,
  testID = '',
  tintColor,
}: IProps): JSX.Element | null {
  if (!imageUrl) {
    return null;
  }

  return (
    <View
      style={[
        styles.container,
        {
          width: size,
          height: size,
          borderRadius,
          backgroundColor,
        },
        style,
      ]}
      testID={testID}
    >
      <KitImage
        style={{
          width: size,
          height: size,
          borderRadius,
          tintColor,
        }}
        source={{
          uri: parseImageUrl(imageUrl, size, size, ImageServiceType.ImagePng),
        }}
      />
    </View>
  );
}

//******************************************************************************
// Styles
//******************************************************************************

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.N200,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
